<template>
    <div class="w-full flex flex-col justify-center my-2">
        <div class="flex flex-wrap justify-center">
            <div
                v-if="!!error"
                class="bg-theme-danger p-2 text-white border-sm"
                role="alert"
            >
                {{ error }}
            </div>
        </div>

        <div v-if="wasUploaded" class="flex justify-center">
            <div class="alert alert-success p-2">
                <a :href="url" target="_blank" rel="noopener">
                    {{ itemCurrent.name }}
                </a>
            </div>
        </div>
        <div v-else class="flex flex-wrap justify-center">
            <label
                class="w-64 flex flex-col items-center px-4 py-6 btn bg-theme-success cursor-pointer rounded-lg text-uppercase"
            >
                <img
                    src="@/assets/images/upload.svg"
                    height="20"
                    width="20"
                    alt="Private upload file"
                />
                <span class="mt-2 text-white leading-normal">
                    {{ selectedFile ? file.name : "Selecciona archivo" }}
                </span>
                <input
                    id="application-uploader"
                    :disabled="isLoading"
                    type="file"
                    accept="image/*,application/pdf"
                    class="hidden"
                    @input="clickUploadButton($event)"
                />
            </label>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
    name: "PrivateFileUploader",
    model: {
        prop: "itemCurrent",
        event: "change"
    },
    props: {
        itemCurrent: {
            type: Object,
            required: false,
            default: () => ({ name: "", url: "" })
        },
        autoApprove: {
            default: () => false,
            type: Boolean,
            required: false
        },
        autoLoader: {
            default: () => false,
            type: Boolean,
            required: false
        }
    },
    data: () => ({
        url: "",
        error: "",
        isLoading: false,
        wasUploaded: false,
        selectedFile: false,
        file: { size: 0, name: "" }
    }),
    computed: {
        ...mapGetters("control", ["backgroundColor"])
    },
    methods: {
        ...mapActions("files", ["getEndPointUploadPrivateFile", "uploadFile"]),
        async clickUploadButton(event) {
            const auxFile = event.target.files || event.dataTransfer.files;
            if (!auxFile.length) return;
            await this.uploadFile(auxFile[0]);
        },
        async uploadFile(file) {
            this.file = {
                size: file.size / 1048576,
                name: file.name
            };
            if (this.file.size > 40) {
                this.error = "Archivo Demasiado Pesado Máximo 40 MB";
                return;
            }
            this.error = "";

            if (!this.autoApprove) {
                const dialogResult = await this.$swal.fire({
                    background: this.backgroundColor,
                    title: `Aseguras que ${this.file.name} es el archivo adecuado ?`,
                    icon: "info",
                    showCancelButton: true,
                    focusConfirm: false,
                    confirmButtonText: "Si",
                    cancelButtonText: "No 😖",
                    confirmButtonColor: "#02913f",
                    cancelButtonColor: "#d33ddd",
                    allowOutsideClick: false
                });
                if (!dialogResult.isConfirmed) {
                    this.selectedFile = false;
                    return;
                }
            }

            this.isLoading = true;
            this.$emit("loading", true);
            if (this.autoLoader) {
                this.$loading.show();
            }
            try {
                const { url, urlSigned } =
                    await this.getEndPointUploadPrivateFile({
                        fileName: this.file.name,
                        fileSize: this.file.size
                    });
                this.url = url;
                this.$emit("change", {
                    url,
                    name: this.file.name
                });
                await this.uploadFile({
                    url: urlSigned,
                    file
                });
                this.$emit("created", {
                    url,
                    name: this.file.name
                });
                this.wasUploaded = true;
                this.$emit("loading", false);
                this.$loading.hide();
                this.isLoading = false;
            } catch (error) {
                this.$emit("loading", false);
                this.$loading.hide();
                this.isLoading = false;
                this.$loading.hide();
                this.error = error.message;
                this.$sound.play("error");
                this.wasUploaded = false;
                this.file = { name: "", size: 0 };
            }
        }
    }
};
</script>
